import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Icons
import "bootstrap-icons/font/bootstrap-icons.css";
import "remixicon/fonts/remixicon.css";

// import Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import "./App.css";

//Import Pages

import Login from "./components/registration/signin/Login";
import UpdatePassword from "./components/registration/credentialupdate/UpdatePassword";
import Header from "./components/header/Header";
import SideBar from "./components/sidebar/SideBar";
import Main from "./components/main/Main";
import Footer from "./components/footer/Footer";
import BackToTop from "./components/backtotop/BackToTop";
import NotFound from "./components/404/NotFound";
import DashboardLayout from "./components/dashboardlayout/DashboardLayout";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/passwordreset" element={<UpdatePassword />} />
          <Route
            path="/"
            element={
              <DashboardLayout>
                <Main />
              </DashboardLayout>
            }
          >
            <Route path="dashboard" element={<Main />} />
            <Route path="customer" element={<Main />} />
            <Route path="gender" element={<Main />} />
            <Route path="item" element={<Main />} />
            <Route path="uom" element={<Main />} />
            <Route path="sales" element={<Main />} />
            <Route path="salesedit" element={<Main />} />
            <Route path="collection" element={<Main />} />
            <Route path="collectionreport" element={<Main />} />
            <Route path="salesreport" element={<Main />} />
            <Route path="summaryreport" element={<Main />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
